import { useTheme as muiUseTheme } from "@mui/material";

/**
 * useTheme hook wrapper for theme access.
 * Wraps Material-UI useTheme for consistent imports.
 * 
 * @example
 * const theme = useTheme();
 */
export const useTheme = () => {
  return muiUseTheme();
};

export default useTheme;
